import TheGrid from '@/views/dealers/lastsales/grid'

export default {
  path: '/dealers/lastsales',
  redirect: '/dealers/lastsales/index',
  name: 'lastsales',
  meta: {
    auth: {
      redirect: {
        name: 'lastsales.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Últimas Vendas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'lastsales.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
